<template>
  <div @click="showHelper">
        <h2 v-bind:class="{ 'h2_black': this.black, 'h2_white': !this.black }">Search operators</h2>
        <ul>
          <li><span class="string">“Zwarte Piet”</span> — exact</li>
          <li><span class="string">Zwarte + piet</span> — resultaten met zowel zwarte en piet</li>
          <li><span class="string">-Feyenoord Ajax</span> — resultaten zonder Feyenoord</li>
          <li><span class="string">Feyenoord | Ajax</span> — Feyenoord of Ajax</li>
          <li><span class="string">Pegtold~</span> — fuzzy search, geeft Pechtold als resultaat</li>
          <li><span class="string">“Hoe dan”~3</span> — maximaal drie andere woorden tussen ‘hoe’ en ‘dan’</li>
          <li><span class="string">vis*</span> — resultaten die beginnen met vis...</li>
        </ul>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Helper',
  methods: {
    showHelper () {
      this.$emit('click', false)
    },
  }
}
</script>

<style scoped>
div {
  position: absolute;
  background: rgb(237,113,108);
  background: linear-gradient(90deg, rgba(237,113,108,1) 0%, rgba(237,113,108,0) 100%);
  width: 80%;
  height: 100vh;
  z-index: 10;
  animation: fadein 2s;
  top: 0;
  padding-left: 10%;
  padding-top: 24%;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

ul {
  list-style-type: none;
  padding-left: 30px
}

li {
  color: white;
  font-family: 'fl-mono', sans-serif;
  margin-top: 10px;
  font-size: 14px;
}

h2 {
  font-family: 'Feijoa-Medium', serif;
  font-weight: 100;
  color: white;
  font-size: 1.28571429rem;
  padding: 30px;
}

.string {
  background: #353535;
  color: #a7a7a7;
  padding: 3px 8px;
  border-radius: 5px;
}
</style>





// WEBPACK FOOTER //
// src/components/Helper.vue